import React, {Component} from 'react';
import { connect} from 'react-redux'
import {bindActionCreators, compose} from 'redux'
import CTable from '@/components/CTable'
import CButton from '@/components/CButton'
import CBaseComponent from '@/components/CBaseComponent'
import { setReload } from "@/redux/common/action";
import _ from 'lodash'
import { tableData} from './data'
import './index.scss'

import { normaluserlist,usernormaldelete } from "@/servers/goodsManageApi";
import { getStoreCategoryList } from "@/servers/commonApi";
import {withRouter} from "react-router-dom";
import {message, Modal} from 'antd'
@CBaseComponent
class GoodsManageList extends Component{
  constructor(props) {
    super(props);
    this.getListData = this.getListData.bind(this);
    this.addHandler = this.addHandler.bind(this);
    this.editHandler = this.editHandler.bind(this);
    this.deleteHandler = this.deleteHandler.bind(this);
    this.modalOk = this.modalOk.bind(this);
    this.modalCancel = this.modalCancel.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    // reload时重新加载数据
    // this.getListData();
  }


  state = {
    columns: tableData.tHead,
    dataSource: tableData.tBody,
    page: tableData.tPage,
    loading: true,
    modal: {
      title: '删除数据',
      visible: false,
    },
    deleteid:''
  };

  modalCancel(){
    this.setState({
      modal: {...this.state.modal, visible: false},
      deleteid:''
    })
  }

  modalOk(){
    const params = {
      id: this.state.deleteid
    }
    usernormaldelete(params).then(res=>{
      if (res.statecode === 0) {
        message.success('删除成功');
        this.modalCancel()
        this.getListData()
      } else {
        message.error('删除失败');
      }
    })
  }

  // 获取用户列表数据
  getListData(){
    let getData = {
      id: ''
    };
    this.setState({
      loading: true
    });
    normaluserlist(getData).then(res=>{
      let data =JSON.parse(JSON.stringify(res.records[0].datalist))
      let total = 1;
      this.setState({
        dataSource: data,
        page: {...this.state.page, total},
        loading: false
      });
    }).catch(err=>{
      console.log(err,'rttt')
    })
  }

  getStoreCategoryListData(){
    getStoreCategoryList().then(res=>{
      let data = res.data.list;
      let list = [];
      data.forEach(item=>{
        list.push({
          value: item.id,
          text: item.name
        })
      });
      let columncsClone = _.cloneDeep(this.state.columns);
      columncsClone.forEach(item=>{
        if(item.key === 'category'){
          item.filters = list
        }
      });
      this.setState({
        columns: columncsClone
      });
    }).catch(err=>{

    })
  }

  /*新增*/
  addHandler(){
    this.props.history.push({
      pathname: '/informationDeclaration/addcountry',
      search: '?type=new'
    })
  }

  // 编辑当前行
  editHandler(data){
    sessionStorage.setItem('countryuser', JSON.stringify(data))
    this.props.history.push({
      pathname: '/informationDeclaration/addcountry',
      search: `?type=edit&id=${data.id}`
    })
  }

  deleteHandler(data){
    this.setState({
      modal: {...this.state.modal, visible: true},
      deleteid:data.id
    })
  }


  componentWillMount(){

  }

  componentDidMount(){
    this.getListData();
  }
  render(){
    return (
        <div className='user-manage-list'>
          <div className='flex filter-wrap'>
            <div className='flex filter-left'>
              <CButton type='primary' authId='goodsManageListNewAdd' onClick={this.addHandler}>新增</CButton>
            </div>
          </div>
          <CTable ref='userManageList' checked={false} loading={this.state.loading} columns={this.state.columns} dataSource={this.state.dataSource} onTableChange={this.onTableChange}>
            <div
                slot='index'
                render={(text, record, index) => (
                    <div className='operate'>
                      {index+1}
                    </div>
                )} />
            <div
                slot='operate1'
                render={(text, record, index) => (
                    <div className='operate'>
                      <CButton type='text' authId='goodsManageListEdit' onClick={() => this.editHandler(record)}>编辑</CButton>
                    </div>
                )} />
            <div
                slot='operate'
                render={(text, record, index) => (
                    <div className='operate'>
                      <CButton type='text' authId='goodsManageListEdit' onClick={() => this.deleteHandler(record)}>删除</CButton>
                    </div>
                )} />
          </CTable>
          <Modal
              title={this.state.modal.title}
              visible={this.state.modal.visible}
              onOk={this.modalOk}
              onCancel={this.modalCancel}
              closable={false}
              width={280}
          >
            <div>
              确认删除此数据?
            </div>
          </Modal>
        </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    reload: state.reload,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    setReload: bindActionCreators(setReload, dispatch)
  }
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(GoodsManageList);
